{
  "uploading": "Laster opp...",
  "pending_upload": "Venter på opplasting",
  "retry": "Prøv igjen",
  "save": "Lagre",
  "saveChanges": "Lagre endringer",
  "savingChanges": "Lagrer...",
  "close": "Lukk",
  "logOut": "Logg ut",
  "logIn": "Logg inn",
  "activate": "Opprett",
  "cancel": "Avbryt",
  "abort": "Avbryt",
  "from": "Fra",
  "to": "Til",
  "on": "på ",
  "and": " og ",
  "error": {
    "title": "Noe gikk galt",
    "description": "En feil har oppstått. Prøv igjen senere."
  },
  "notAvailable": "Ikke tilgjengelig",
  "notRegistered": "Ikke registrert",
  "description": "Beskrivelse",
  "balance": "Saldo",
  "choose_file": "Velg fil",
  "choose_files": "Velg filer",
  "no_file_chosen": "Ingen fil er valgt",
  "no_files_uploaded": "Ingen filer lastet opp",
  "uploaded_files": "Opplastede filer",
  "files_chosen": "{{count}} filer valgt",
  "upload_files": "Last opp filer",
  "downloadFile": "Last ned {{fileName}}",
  "remove": "Fjern",
  "delete": "Slett",
  "deleting": "Sletter...",
  "uploaded": "Opplastet",
  "search": "Søk",
  "add": "Legg til",
  "edit": "Endre",
  "back": "Tilbake",
  "next": "Neste",
  "requiredField": "Dette feltet er obligatorisk",
  "optional": "(valgfritt)",
  "newestFirst": "Nyeste først",
  "oldestFirst": "Eldste først",
  "clearDateRange": "Fjern datoperiode",
  "clearFilter": "Fjern filter",
  "selectDate": "Velg en dato",
  "selectDateRange": "Velg datoperiode",
  "month": "Måned",
  "year": "År",
  "datePicker": {
    "invalidFormat": "Ugyldig datoformat. Vennligst bruk dd.mm.åååå",
    "invalidDate": "Ugyldig dato",
    "cannotSelectFuture": "Du kan ikke velge en dato som er frem i tid",
    "cannotSelectPast": "Du kan ikke velge en dato som er tilbake i tid",
    "cannotSelectBefore": "Du kan ikke velge en dato før {{date}}",
    "cannotSelectAfter": "Du kan ikke velge en dato etter {{date}}",
    "cannotSelectUnavailable": "Du kan ikke velge en dato som er opptatt",
    "unavailableDate": "opptatt"
  },
  "noOwnersFound": "Ingen eiere funnet",
  "showAllOwners": "Vis alle eiere",
  "removeProperty": "Fjern eiendom",
  "ok": "OK",
  "continue": "Fortsett",
  "abortDialog": {
    "title": "Er du sikker på at du vil avbryte?",
    "description": "Endringene du har gjort vil ikke bli lagret",
    "actionLabel": "Avbryt uten å lagre",
    "cancelLabel": "Fortsett redigering"
  },
  "yes": "Ja",
  "no": "Nei",
  "noResults": "Ingen resultater"
}
